import api from "../config/api";
import { Holiday } from "../types/Holiday";

const API_URL = "/holidayMaster";

// Get all holidays
export const getHolidays = () =>
  api.get(`${API_URL}/`).then((res) => res.data.data);

// Get holiday by ID
export const getHolidayById = (id: number) => api.get(`${API_URL}/?id=${id}`);

// Create holiday
export const createHoliday = (data: Holiday) => api.post(`${API_URL}/`, data);

// Update holiday
export const updateHoliday = (id: number, data: Holiday) =>
  api.put(`${API_URL}/?id=${id}`, data);

// Delete holiday
export const deleteHoliday = (id: number) => api.delete(`${API_URL}/?id=${id}`);
